import { checkboxTV } from './checkbox.styles.esm.js';

var checkboxVariantList = Object.keys(checkboxTV.variants.variant);

export { checkboxVariantList };
//# sourceMappingURL=types.esm.js.map
